import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";

export default function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/api/auth/signup/start", { name, email, password });
      navigate("/verify?email=" + encodeURIComponent(email) + "&purpose=signup");
    } catch (e) {
      alert(e?.response?.data?.error || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  const panelImg = (process.env.PUBLIC_URL || "") + "/court8.jpg";
  const pageBg = (process.env.PUBLIC_URL || "") + "/court7.jpg";

  return (
    <div
      className="relative min-h-screen flex items-center justify-center p-4 bg-[var(--bg)] text-[var(--fg)]"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(59,130,246,0.08), rgba(16,185,129,0.08)), url(${pageBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-[var(--bg)]/85 backdrop-blur-sm" />

      <div className="relative z-10 w-full max-w-md md:max-w-lg grid grid-cols-1 md:[grid-template-columns:38%_62%] rounded-2xl overflow-hidden surface-card">
        <div className="relative hidden md:block md:min-h-[420px]">
          <img src={panelImg} alt="State emblem & gavel" className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/25 to-black/10" />
          <div className="absolute bottom-3 left-3 right-3 bg-white/80 backdrop-blur px-3 py-1.5 rounded-md text-[11px] text-slate-700 shadow">
            Secure access · New York Courts
          </div>
        </div>

        <div className="p-6 bg-[var(--surface)]">
          <p className="page-kicker">Get started</p>
          <h1 className="page-title">Create your account</h1>
          <p className="page-subtitle mt-1 mb-4">It only takes a minute</p>

          <form onSubmit={submit} className="space-y-3">
            <div>
              <label className="block text-xs font-medium text-[var(--fg)] mb-1">Full name</label>
              <input
                className="w-full ui-input"
                placeholder="Jane Doe"
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoComplete="name"
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-[var(--fg)] mb-1">Email</label>
              <input
                className="w-full ui-input"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-[var(--fg)] mb-1">Password</label>
              <input
                type="password"
                className="w-full ui-input"
                placeholder="Create a strong password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
              />
              <p className="mt-1 text-[11px] text-[var(--fg-muted)]">
                At least 8 characters, include a number and a symbol.
              </p>
            </div>

            <button
              disabled={loading}
              className="w-full ui-btn ui-btn-primary"
            >
              {loading ? "Creating..." : "Create account"}
            </button>
          </form>

          <div className="flex items-center gap-2 my-4">
            <div className="h-px flex-1 bg-[var(--border)]" />
            <span className="text-[10px] uppercase text-[var(--fg-muted)] tracking-wider">or</span>
            <div className="h-px flex-1 bg-[var(--border)]" />
          </div>

          <button
            onClick={() => navigate("/login")}
            className="w-full ui-btn"
          >
            Already have an account? Sign in
          </button>
        </div>
      </div>
    </div>
  );
}
